document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-mobile-drawer]');
  const menu = document.querySelector('[data-menu-toggle]');
  if (menu && drawer) {
    menu.addEventListener('click', () => {
      const open = !drawer.hasAttribute('hidden');
      if (open) { drawer.setAttribute('hidden',''); menu.setAttribute('aria-expanded','false'); }
      else { drawer.removeAttribute('hidden'); menu.setAttribute('aria-expanded','true'); }
    });
  }
  const searchDrawer = document.querySelector('[data-search-drawer]');
  const searchToggle = document.querySelector('[data-search-toggle]');
  if (searchDrawer && searchToggle) searchToggle.addEventListener('click', () => searchDrawer.toggleAttribute('hidden'));

  const filterToggle = document.querySelector('[data-filter-toggle]');
  if (filterToggle) {
    filterToggle.addEventListener('click', () => {
      const panel = filterToggle.closest('[data-filter-panel]');
      const isOpen = panel.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  // Desktop nav dropdowns: click to open/close, closes on outside click or Escape
  const navDropdowns = document.querySelectorAll('[data-nav-dropdown]');
  navDropdowns.forEach(dropdown => {
    const trigger = dropdown.querySelector('[data-nav-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = dropdown.classList.contains('is-open');
      navDropdowns.forEach(d => { d.classList.remove('is-open'); const t = d.querySelector('[data-nav-trigger]'); if (t) t.setAttribute('aria-expanded','false'); });
      if (!isOpen) { dropdown.classList.add('is-open'); trigger.setAttribute('aria-expanded','true'); }
    });
  });
  document.addEventListener('click', () => {
    navDropdowns.forEach(d => { d.classList.remove('is-open'); const t = d.querySelector('[data-nav-trigger]'); if (t) t.setAttribute('aria-expanded','false'); });
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') navDropdowns.forEach(d => { d.classList.remove('is-open'); const t = d.querySelector('[data-nav-trigger]'); if (t) t.setAttribute('aria-expanded','false'); });
  });

  document.querySelectorAll('[data-metal-picker]').forEach(picker => {
    picker.addEventListener('click', event => {
      const button = event.target.closest('[data-metal]');
      if (!button) return;
      picker.querySelectorAll('[data-metal]').forEach(b => b.classList.remove('is-active'));
      button.classList.add('is-active');
      const card = picker.closest('[data-product-card]');
      if (!card) return;
      const price = card.querySelector('[data-card-price]');
      if (price) price.textContent = button.dataset.price;
      card.querySelectorAll('a[href]').forEach(a => {
        if (a.href.includes('/products/')) {
          const base = a.href.split('?')[0];
          a.href = base + '?variant=' + button.dataset.variantId;
        }
      });
    });
  });

  // Gallery thumbnails and quantity steppers: wired up first, independent of
  // the variant-selection logic below, so a problem in one never blocks the other.
  document.querySelectorAll('[data-gallery-image]').forEach(button => button.addEventListener('click', () => {
    const main = document.querySelector('[data-main-image] img');
    if (main) {
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = button.dataset.galleryImage;
    }
    document.querySelectorAll('[data-gallery-image]').forEach(b => b.classList.remove('is-active')); button.classList.add('is-active');
    button.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }));
  // Preload full-size gallery/carousel images once the page has finished loading, so
  // clicking a thumbnail (or switching variants) swaps to an already-cached image
  // instead of triggering a fresh network fetch that visibly lags.
  const preloadGalleryImages = () => {
    const urls = new Set();
    document.querySelectorAll('[data-gallery-image]').forEach(button => {
      if (button.dataset.galleryImage) urls.add(button.dataset.galleryImage);
    });
    document.querySelectorAll('[data-carousel-image]').forEach(slide => {
      if (slide.dataset.carouselImage) urls.add(slide.dataset.carouselImage);
    });
    urls.forEach(url => { const preloadImg = new Image(); preloadImg.src = url; });
  };
  if (document.readyState === 'complete') {
    preloadGalleryImages();
  } else {
    window.addEventListener('load', preloadGalleryImages, { once: true });
  }
  // Mobile image carousel: swipe via native scroll-snap, dots track position via IntersectionObserver
  const carousel = document.querySelector('[data-product-carousel]');
  const dotsWrap = document.querySelector('[data-carousel-dots]');
  if (carousel) {
    const slides = Array.from(carousel.querySelectorAll('.carousel-slide'));
    const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.carousel-dot')) : [];
    if (dots.length) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            const idx = slides.indexOf(entry.target);
            dots.forEach(d => d.classList.remove('is-active'));
            if (dots[idx]) dots[idx].classList.add('is-active');
          }
        });
      }, { root: carousel, threshold: [0.6] });
      slides.forEach(slide => observer.observe(slide));
      dots.forEach(dot => dot.addEventListener('click', () => {
        const idx = Number(dot.dataset.dotIndex);
        if (slides[idx]) slides[idx].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }));
    }
    carousel.goToImage = (url) => {
      const cleanUrl = url.split('?')[0];
      const slide = slides.find(s => s.dataset.carouselImage.split('?')[0] === cleanUrl);
      if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    };
  }

  document.querySelectorAll('[data-qty-minus]').forEach(button => button.addEventListener('click', () => {
    const input = button.parentElement.querySelector('input'); if (input) input.value = Math.max(1, Number(input.value || 1) - 1);
  }));
  document.querySelectorAll('[data-qty-plus]').forEach(button => button.addEventListener('click', () => {
    const input = button.parentElement.querySelector('input'); if (input) input.value = Number(input.value || 1) + 1;
  }));

  const productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    try {
      const productData = document.querySelector('[data-product-json]');
      const product = productData ? JSON.parse(productData.textContent) : null;
      const selected = {};
      productForm.querySelectorAll('[data-option-index]').forEach(button => {
        if (button.classList.contains('is-selected')) selected[button.dataset.optionIndex] = button.dataset.optionValue;
      });
      const syncVariant = () => {
        if (!product) return;
        const variant = product.variants.find(v => v.options.every((value, index) => selected[index] === value));
        if (!variant) return;
        const idInput = productForm.querySelector('[data-variant-id]');
        if (idInput) idInput.value = variant.id;
        const price = document.querySelector('[data-product-price]');
        if (price) { const currency = document.body.dataset.currency || 'USD'; price.textContent = new Intl.NumberFormat('en-US', {style:'currency', currency:currency}).format(variant.price / 100); }
        const add = productForm.querySelector('.add-button');
        if (add) { add.disabled = !variant.available; add.textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT'; }
        const stickyPrice = document.querySelector('.mobile-sticky-cta .cta-price');
        if (stickyPrice) { const currency = document.body.dataset.currency || 'USD'; stickyPrice.textContent = new Intl.NumberFormat('en-US', {style:'currency', currency:currency}).format(variant.price / 100); }
        if (variant.featured_image && variant.featured_image.src) {
          const mainImg = document.querySelector('[data-main-image] img');
          if (mainImg) {
            mainImg.removeAttribute('srcset');
            mainImg.removeAttribute('sizes');
            mainImg.src = variant.featured_image.src;
          }
          document.querySelectorAll('[data-gallery-image]').forEach(b => {
            const bUrl = b.dataset.galleryImage.split('?')[0];
            const vUrl = variant.featured_image.src.split('?')[0];
            b.classList.toggle('is-active', bUrl === vUrl);
          });
          const carouselEl = document.querySelector('[data-product-carousel]');
          if (carouselEl && carouselEl.goToImage) carouselEl.goToImage(variant.featured_image.src);
        }
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url.toString());
      };
      productForm.querySelectorAll('[data-option-index]').forEach(button => button.addEventListener('click', () => {
        try {
          const index = button.dataset.optionIndex;
          productForm.querySelectorAll('[data-option-index="'+index+'"]').forEach(b => b.classList.remove('is-selected'));
          button.classList.add('is-selected'); selected[index] = button.dataset.optionValue; syncVariant();
        } catch (err) { console.error('Variant selection error:', err); }
      }));
      syncVariant();
    } catch (err) { console.error('Product form init error:', err); }
  }

  // Combined material / category / month filtering — all in-page, no navigation.
  // Material-only filter chips exist on every collection page; category and month
  // filters only render on the birthstone-jewelry page, so filterState.category and
  // .month simply stay 'all' (no-op) everywhere else.
  const filterState = { material: 'all', category: 'all', month: 'all' };
  const applyFilters = () => {
    let visibleCount = 0;
    document.querySelectorAll('[data-product-card]').forEach(card => {
      const cardMaterials = Array.from(card.querySelectorAll('[data-metal]')).map(b => b.dataset.metal.toLowerCase());
      const materialMatch = filterState.material === 'all' || cardMaterials.some(n => filterState.material === 'silver' ? (n.includes('silver') || n.includes('sterling')) : (n.includes('vermeil') || n.includes('gold')));
      const categoryMatch = filterState.category === 'all' || card.dataset.category === filterState.category;
      // A card can legitimately belong to more than one month (a design with
      // real per-month photography tagged birth-month-january birth-month-february
      // etc.), so data-month is a space-separated list, not a single value.
      const cardMonths = (card.dataset.month || '').split(' ').filter(Boolean);
      const monthMatch = filterState.month === 'all' || cardMonths.includes(filterState.month);
      const visible = materialMatch && categoryMatch && monthMatch;
      card.hidden = !visible;
      if (visible) visibleCount++;
    });
    const emptyState = document.querySelector('.filter-empty-state');
    if (emptyState) emptyState.hidden = visibleCount !== 0;
  };

  document.querySelectorAll('[data-filter-material]').forEach(filter => filter.addEventListener('click', () => {
    filterState.material = filter.dataset.filterMaterial;
    document.querySelectorAll('[data-filter-material]').forEach(f => f.classList.remove('is-active')); filter.classList.add('is-active');
    applyFilters();
  }));

  document.querySelectorAll('[data-filter-category]').forEach(filter => filter.addEventListener('click', () => {
    filterState.category = filter.dataset.filterCategory;
    document.querySelectorAll('[data-filter-category]').forEach(f => f.classList.remove('is-active')); filter.classList.add('is-active');
    applyFilters();
  }));

  document.querySelectorAll('[data-filter-month]').forEach(filter => filter.addEventListener('click', () => {
    const value = filter.dataset.filterMonth;
    const wasActive = filter.classList.contains('is-active');
    document.querySelectorAll('[data-filter-month]').forEach(f => f.classList.remove('is-active'));
    if (wasActive) {
      filterState.month = 'all';
    } else {
      filter.classList.add('is-active');
      filterState.month = value;
    }
    const monthSelect = document.querySelector('[data-filter-month-select]');
    if (monthSelect) monthSelect.value = filterState.month;
    applyFilters();
    const grid = document.querySelector('.collection-grid');
    if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));

  // Mobile "Shop by Birth Month" dropdown — same filterState, no navigation.
  // Mirrors the desktop pill grid so switching viewport width keeps state in sync.
  const monthSelect = document.querySelector('[data-filter-month-select]');
  if (monthSelect) {
    monthSelect.addEventListener('change', () => {
      filterState.month = monthSelect.value;
      document.querySelectorAll('[data-filter-month]').forEach(f => f.classList.toggle('is-active', f.dataset.filterMonth === filterState.month));
      applyFilters();
      const grid = document.querySelector('.collection-grid');
      if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // Wishlist: client-side, persisted in localStorage (no wishlist app installed).
  // Stores an array of product handles under "ammy_wishlist".
  const WISHLIST_KEY = 'ammy_wishlist';
  const getWishlist = () => {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (err) { return []; }
  };
  const setWishlist = (list) => {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (err) { /* storage unavailable, ignore */ }
  };
  const syncWishlistButtons = () => {
    const list = getWishlist();
    document.querySelectorAll('[data-product-card]').forEach(card => {
      const handle = card.dataset.productHandle;
      const button = card.querySelector('.wishlist-button');
      if (!button || !handle) return;
      const active = list.includes(handle);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };
  document.querySelectorAll('.wishlist-button').forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const card = button.closest('[data-product-card]');
      const handle = card ? card.dataset.productHandle : null;
      if (!handle) return;
      let list = getWishlist();
      if (list.includes(handle)) {
        list = list.filter(h => h !== handle);
      } else {
        list.push(handle);
      }
      setWishlist(list);
      syncWishlistButtons();
    });
  });
  syncWishlistButtons();

  // First-time visitor 10% off signup popup
  const popup = document.querySelector('[data-signup-popup]');
  if (popup) {
    const POPUP_KEY = 'ammy_signup_popup_seen';
    const alreadySeen = () => { try { return localStorage.getItem(POPUP_KEY) === '1'; } catch (err) { return false; } };
    const markSeen = () => { try { localStorage.setItem(POPUP_KEY, '1'); } catch (err) { /* ignore */ } };
    const openPopup = () => { popup.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    const closePopup = () => { popup.classList.remove('is-open'); document.body.style.overflow = ''; markSeen(); };
    if (!alreadySeen()) {
      setTimeout(openPopup, 4000);
    }
    const closeBtn = popup.querySelector('[data-popup-close]');
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    popup.addEventListener('click', (event) => { if (event.target === popup) closePopup(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && popup.classList.contains('is-open')) closePopup(); });
    const popupForm = popup.querySelector('form');
    if (popupForm) popupForm.addEventListener('submit', markSeen);
  }
});
